/**
 * CollectionSettlementRequest permissions — operational settlement (Batch 5-A).
 */

export const COLLECTION_SETTLEMENT_READ_PERMISSION = 'collection_settlement:read' as const;
export const COLLECTION_SETTLEMENT_CREATE_PERMISSION = 'collection_settlement:create' as const;
export const COLLECTION_SETTLEMENT_SUBMIT_PERMISSION = 'collection_settlement:submit' as const;
export const COLLECTION_SETTLEMENT_APPROVE_PERMISSION = 'collection_settlement:approve' as const;
export const COLLECTION_SETTLEMENT_CANCEL_PERMISSION = 'collection_settlement:cancel' as const;

export const COLLECTION_SETTLEMENT_PERMISSIONS = [
  COLLECTION_SETTLEMENT_READ_PERMISSION,
  COLLECTION_SETTLEMENT_CREATE_PERMISSION,
  COLLECTION_SETTLEMENT_SUBMIT_PERMISSION,
  COLLECTION_SETTLEMENT_APPROVE_PERMISSION,
  COLLECTION_SETTLEMENT_CANCEL_PERMISSION,
] as const;

export type CollectionSettlementPermission = (typeof COLLECTION_SETTLEMENT_PERMISSIONS)[number];

export function isCollectionSettlementPermission(
  permission: string
): permission is CollectionSettlementPermission {
  return (COLLECTION_SETTLEMENT_PERMISSIONS as readonly string[]).includes(permission);
}
